import { render, staticRenderFns } from "./TgPS5HomeTitle.vue?vue&type=template&id=3f1f405f&"
import script from "./TgPS5HomeTitle.vue?vue&type=script&lang=js&"
export * from "./TgPS5HomeTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports